export default "__VITE_ASSET__2b579c44__"